export default "__VITE_ASSET__d69b832b__"